import React, { useEffect, useState, useRef } from 'react';
import { Bar } from 'react-chartjs-2';
import { Chart, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend } from 'chart.js';
import html2canvas from 'html2canvas';
import '../styles/ChartStyles.css'; 

Chart.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

function GraficoPostagemMesAno() {
  const [chartData, setChartData] = useState(null);
  const chartRef = useRef(null);

  useEffect(() => {
    const colorMap = {
      2018: { backgroundColor: 'rgba(255, 99, 132, 0.6)', borderColor: 'rgba(255, 99, 132, 1)' },
      2019: { backgroundColor: 'rgba(255, 159, 64, 0.6)', borderColor: 'rgba(255, 159, 64, 1)' },
      2020: { backgroundColor: 'rgba(54, 162, 235, 0.6)', borderColor: 'rgba(54, 162, 235, 1)' },
      2021: { backgroundColor: 'rgba(75, 192, 192, 0.6)', borderColor: 'rgba(75, 192, 192, 1)' },
      2022: { backgroundColor: 'rgba(99, 132, 255, 0.6)', borderColor: 'rgba(99, 132, 255, 1)' },
      2023: { backgroundColor: 'rgba(135, 150, 179, 0.6)', borderColor: 'rgba(135, 150, 179, 1)' }
    };

    const fetchData = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/data`);
        const data = await response.json();

        if (!data || !Array.isArray(data) || data.length === 0) {
          console.error('Nenhum dado válido foi retornado da API');
          return;
        }

        const aggregatedData = {};

        data.forEach(item => {
          const date = new Date(item._source.data_postagem);
          const month = date.getMonth() + 1;
          const year = date.getFullYear();

          if (!aggregatedData[year]) {
            aggregatedData[year] = Array(12).fill(0);
          }
          aggregatedData[year][month - 1]++;
        });

        const labels = ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'];
        const datasets = Object.keys(aggregatedData).map(year => {
          const color = colorMap[year] || { backgroundColor: 'rgba(201, 203, 207, 0.6)', borderColor: 'rgba(201, 203, 207, 1)' };

          return {
            label: year,
            data: aggregatedData[year],
            backgroundColor: color.backgroundColor,
            borderColor: color.borderColor,
            borderWidth: 1,
          };
        });

        setChartData({
          labels: labels,
          datasets: datasets,
        });
      } catch (error) {
        console.error('Erro ao buscar dados:', error);
      }
    };

    fetchData();
  }, []);

  const exportChart = () => {
    if (chartRef.current && chartRef.current.canvas) {
      html2canvas(chartRef.current.canvas).then((canvas) => {
        const link = document.createElement('a');
        link.href = canvas.toDataURL('image/png');
        link.download = 'Evolução das Postagens por Mês e Ano.png';
        link.click();
      });
    } else {
      console.error('Canvas do gráfico não está disponível');
    }
  };

  const exportData = () => {
    if (chartData) {
      const csvData = chartData.labels.map((label, index) => {
        return chartData.datasets.map(dataset => `${label},${dataset.label},${dataset.data[index]}`).join('\n');
      }).join('\n');
    
      const blob = new Blob([`Mês,Ano,Número de Postagens\n${csvData}`], { type: 'text/csv;charset=utf-8;' });
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.download = 'Evolução das Postagens por Mês e Ano.csv';
      link.click();
    } else {
      console.error('Dados do gráfico não estão disponíveis');
    }
  };

  const options = {
    plugins: {
      title: {
        display: true,
        text: 'Evolução das Postagens por Mês e Ano',
        font: {
          size: 18
        }
      },
      legend: {
        display: true,
        position: 'top'
      },
      tooltip: {
        callbacks: {
          title: function(tooltipItems) {
            return `Mês: ${tooltipItems[0].label}`;
          },
          label: function(tooltipItem) {
            const year = tooltipItem.dataset.label || '';
            const quantity = tooltipItem.raw || 0;
            return `Quantidade de postagens em ${year}: ${quantity}`;
          }
        }
      }
    },
    scales: {
      x: {
        title: {
          display: true,
          text: 'Mês'
        }
      },
      y: {
        title: {
          display: true,
          text: 'Número de Postagens'
        },
        beginAtZero: true
      }
    }
  };

  return (
    <div className="chart-wrapper">
      <div style={{ width: '100%', height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>  
        {chartData ? <Bar ref={chartRef} data={chartData} options={options} /> : <p>Carregando dados...</p>}
      </div>
      <div className="button-container">
        <button className="export-button" onClick={exportData}>Exportar Dados</button>
        <button className="export-button" onClick={exportChart}>Exportar Gráfico</button>
      </div>
    </div>
  );
}

export default GraficoPostagemMesAno; 
